import './DashboardHeader.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { get } from '../../utils';
import useProfile from '../../utils/hooks/useProfile';
var DashboardHeader = function DashboardHeader(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'https://apiqa.testvisitdubai.com';
  var userProfile = useProfile(apiGlobal) || {};
  var introText = fields.data.item.introText.jss.value;
  var fullName = "".concat(userProfile.firstName || '', " ").concat(userProfile.lastName || '');
  var title = fields.data.item.title.jss.value.replace('#username#', "".concat(fullName.trim()));
  return /*#__PURE__*/React.createElement(ComponentsWrapper, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 offset-xl-1 ".concat(DashboardHeaderNameStyles)
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 offset-xl-1 ".concat(DashboardHeaderDescriptionStyles)
  }, introText)));
};
var DashboardHeaderNameStyles = "d1l3wpau";
var DashboardHeaderDescriptionStyles = "d8vl4v";
export default DashboardHeader;